"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixAlignedPhantom = fixAlignedPhantom;
function fixAlignedPhantom(tex) {
    return tex.replace(/&\s*\\phantom\s*(=|\{\s*=\s*})/g, "&\\phantom{{}={}}");
}
